import React from "react";
import { LifeBuoy } from "lucide-react";
import { useAuth } from "../lib/auth";

export function EmergencySessionBanner() {
  const { user } = useAuth();
  const endsAt = user?.emergency_session_expires_at;
  if (!endsAt) return null;
  const time = new Date(endsAt).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  return (
    <div className="px-6 py-2 text-xs flex items-center justify-center gap-2 text-center" style={{ background: "#FBF3E4", color: "#8A5A00" }} data-testid="emergency-session-banner">
      <LifeBuoy size={13} className="shrink-0" />
      {user.drill_session
        ? `Practice session (view-only): ends at ${time}. This drill is being recorded.`
        : `Emergency access session: ends at ${time}. Every action is recorded in the audit log.`}
    </div>
  );
}
